import { useLang } from "../../i18n";
import { Reveal, Overline } from "./Reveal";
import { IMAGES, GALLERY } from "../../data";

export const About = () => {
  const { t } = useLang();

  return (
    <section id="about" data-testid="about-section" className="relative bg-parchment py-24 md:py-36">
      <div className="mx-auto max-w-[1440px] px-6 md:px-14">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <Overline>{t.about.overline}</Overline>
                <h2 className="mt-5 font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ink md:text-6xl">
                  {t.about.title}
                </h2>
              </Reveal>
              <Reveal delay={0.15}>
                <blockquote className="mt-10 border-l-2 border-panettone pl-6 font-serif text-xl italic leading-relaxed text-ink/80 md:text-2xl">
                  {t.about.quote}
                  <footer className="mt-4 text-xs font-semibold uppercase not-italic tracking-[0.2em] text-panettone">
                    {t.about.quoteBy}
                  </footer>
                </blockquote>
              </Reveal>
              <Reveal delay={0.25}>
                <div className="relative mt-12 border border-ink/10 shadow-[0_8px_30px_rgb(0,0,0,0.06)]">
                  <img
                    src={IMAGES.bakery}
                    alt="Panettone — celebratory artwork"
                    className="block w-full"
                  />
                </div>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal delay={0.1}>
              <p className="font-serif text-2xl leading-snug text-ink md:text-3xl">{t.about.p1}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 leading-relaxed text-ink/70">{t.about.p2}</p>
              <p className="mt-5 leading-relaxed text-ink/70">{t.about.p3}</p>
            </Reveal>

            <div className="mt-14 grid grid-cols-2 gap-px bg-ink/10">
              {t.about.stats.map((s, i) => (
                <Reveal key={i} delay={i * 0.08} className="bg-parchment">
                  <div className="p-7 md:p-9" data-testid={`stat-tile-${i}`}>
                    <p className="font-serif text-4xl font-semibold text-panettone md:text-6xl">{s.value}</p>
                    <p className="mt-2 text-[13px] leading-snug text-ink/60">{s.label}</p>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.1}>
              <h3 className="mt-16 font-serif text-2xl font-medium italic text-ink">{t.about.timelineTitle}</h3>
            </Reveal>
            <div className="mt-6">
              {t.about.timeline.map((item, i) => (
                <Reveal key={item.year} delay={i * 0.05}>
                  <div className="flex gap-6 border-t border-ink/10 py-5" data-testid={`timeline-${item.year}`}>
                    <span className="w-16 shrink-0 font-serif text-2xl font-semibold text-panettone">{item.year}</span>
                    <p className="text-[15px] leading-relaxed text-ink/70">{item.text}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>

        {/* photo strip */}
        <div className="mt-20 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {GALLERY.slice(0, 8).map((src, i) => (
            <Reveal key={src} delay={i * 0.08}>
              <div className={`spotlight overflow-hidden ${i % 2 === 1 ? "md:mt-10" : ""}`}>
                <img
                  src={src}
                  alt="Festival atmosphere"
                  loading="lazy"
                  className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out hover:scale-105"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
